export default {
  URLHead: "https://s3.ap-northeast-1.amazonaws.com/alte-meister-static-test/images/",
  FAMILY_EMBLEM: "familyEmblems/custom-preview.png",
  SANSKRIT_CHARACTER: "sanskritCharacters/custom-preview.png",
};
